import {get} from 'lodash';
import Http from '../services/http.service';
import Message from '../services/message.service';
import Notifications from '../services/notification.service';
import Monaco from '../services/monaco.service';
const localStore = require('store');

const USER_KEY = 'user';
const SAVED_KEY = 'saved';
const User = {};
User.user = null;

// Not promises
User.setHttp = () => {
  if (!User.user) return;
  Http.set(User.user);
};
// End not promises

User.isAuthenticated = async () => !!(await User.get());
User.isAccountAdmin = async () => !!(await User.get()).accountAdmin;
User.isSuperAdmin = async () => !!(await User.get()).superAdmin;
User.signout = async () => {
  User.user = null;
  localStore.clearAll();
  return null;
};

User.setSaved = async (saved) => {
  localStore.set(SAVED_KEY, saved);
  return saved;
};
User.getSaved = async () => localStore.get(SAVED_KEY);

User.init = async () => {
  if (!User.user) {
    console.warn('No user set when trying to init things. This should not happen');
    return;
  }
  await User.setHttp();
  await Message.setup();
  Monaco.setup(); // don't care when this finishes
};

User.set = async (user) => {
  User.user = user;          // set the in-memory
  localStore.set(USER_KEY, user); // set the localstore
  await User.init();         // init any services
  return User.user;
};

User.get = async () => {
  if (User.user) return User.user; // cached user
  User.user = localStore.get(USER_KEY); // otherwise, get localstore, refresh and init
  await User.init();
  await User.refreshUser();
  return User.user;
};

User.refreshUser = async () => {
  if (!User.user) {
    console.warn('No user to refresh. Could be a race');
    return false;
  }
  let user;
  if (User.user.assumeAccount) {
    //Don't refresh, so we retain the same assume account token.
    user = User.user; // eslint-disable-line
  } else {
    try {
      user = (await Http.get().get(`${process.env.VUE_APP_API}/1/user`)).data;
    } catch (err) {
      console.error('Unable to get/refresh user:');
      console.error(err);
      if (get(err, 'response.data.message') === 'ACCOUNT_DISABLED') {
        await Notifications.alert('This account has been disabled. Please contact support@bionicmetrics.com to re-enable your account.');
        await User.signout();
      }

      if (get(err, 'response.data.message') === 'USER_DISABLED') {
        await Notifications.alert('This user is not enabled. You have been signed out.');
        await User.signout();
      }
    }
  }
  return User.set(user);
};
User.changePassword = async (currentPassword, newPassword) => {
  const user = (await Http.get().put(`${process.env.VUE_APP_API}/1/user/${User.user._id}/password`, {currentPassword, newPassword})).data;
  return User.update(user);
};

User.setTheme = async (dark) => {
  const theme = dark ? 'dark' : 'light';
  const user = (await Http.get().put(`${process.env.VUE_APP_API}/1/user/${User.user._id}/theme/${theme}`)).data;
  return User.update(user);
};

User.update = async (toSet) => {
  const updatedUser = (await Http.get().put(`${process.env.VUE_APP_API}/1/user/${toSet._id}`, toSet)).data;
  return User.set(updatedUser);
};

User.isLocalRunning = async () => (await Http.get().get(`${process.env.VUE_APP_API}/1/user/local`)).data;

export default User;
